import { css } from 'lit';
export default css `
  wui-flex,
  wui-list-wallet {
    width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map